export default __webpack_public_path__ + "static/media/mrle-vanoce.688c09e2.jpg";